import { EventEmitter } from '@angular/core';
import { MeasureModule } from '../../../../models/measure/measure-module';
import { measureModuleIconPath } from '../../../app.constants';
import { UserService } from '../../../services/user.service';
var MeasureModulesSelectionComponent = /** @class */ (function () {
    function MeasureModulesSelectionComponent(userService) {
        this.userService = userService;
        this.module = new MeasureModule();
        this.afterDropCallback = new EventEmitter();
        this.activeCallback = new EventEmitter();
        this.isActivated = true;
    }
    Object.defineProperty(MeasureModulesSelectionComponent.prototype, "iconPath", {
        get: function () {
            var _this = this;
            if (!this.module) {
                return '';
            }
            var keyIcon = Object.keys(measureModuleIconPath).find(function (key) { return _this.module.id === measureModuleIconPath[key].id; });
            return keyIcon && this.module.isActive ? measureModuleIconPath[keyIcon].path : measureModuleIconPath[keyIcon].inactivePath;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MeasureModulesSelectionComponent.prototype, "checkmarkIcon", {
        get: function () {
            return this.module.isActive ? 'assets/images/Check_Green.svg' : 'assets/images/Check_Dark.svg';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MeasureModulesSelectionComponent.prototype, "dropData", {
        get: function () {
            return {
                index: this.index,
                module: this.module,
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MeasureModulesSelectionComponent.prototype, "moduleName", {
        get: function () {
            if (!this.module) {
                return '';
            }
            return this.module.name;
        },
        enumerable: true,
        configurable: true
    });
    MeasureModulesSelectionComponent.prototype.onAnyDrop = function (e) {
        if (!this.isFreeUser && this.canEditable) {
            this.afterDropCallback.emit({
                draggedModuleIndex: e.dragData.index,
                droppedModuleIndex: this.index,
                draggedModule: e.dragData.module,
                droppedModule: this.module
            });
        }
    };
    MeasureModulesSelectionComponent.prototype.onActivatedModule = function (moduleId) {
        if (!this.isFreeUser && this.canEditable) {
            this.isActivated = true;
            this.activeCallback.emit(moduleId);
        }
    };
    Object.defineProperty(MeasureModulesSelectionComponent.prototype, "isFreeUser", {
        get: function () {
            return this.userService.isFreeUser();
        },
        enumerable: true,
        configurable: true
    });
    return MeasureModulesSelectionComponent;
}());
export { MeasureModulesSelectionComponent };



// WEBPACK FOOTER //
// ./src/app/main/measure/measure-modules-selection/measure-modules-selection.component.ts.pre-build-optimizer.js